

export const mapUrl = project =>
  encodeURI(
    "https://www.google.ch/maps/search/?api=1&query=" +
      (project.latitude && project.longitude
        ? project.latitude + "," + project.longitude
        : project.street + "," + project.zip + "," + project.city + ", Schweiz")
  )
